export const LISTILT_REQUEST = "LISTILT_REQUEST";
export const LISTILT_SUCCESS = "LISTILT_SUCCESS";
export const LISTILT_ERROR = "LISTILT_ERROR";
export const LISTILT_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'AppILTV1',
    size: 1000,
    filter: []
};